export default __webpack_public_path__ + "static/media/email-icon.200a94a3.svg";